import styled from '@emotion/styled'
import { containers } from 'style';
const alignment = align => {
    if (align == 'right') {
        return `margin-left: auto`;
    }
    if (align == 'center') {
        return `margin: 0 auto`;
    }
    return `margin-right: auto`;
};

export const getSize = (teaserImageWide, teaserImageTall) => {
    if (teaserImageWide) {
        return teaserImageWide;
    }
    if (teaserImageTall) {
        return teaserImageTall;
    }
    return { width: 0, height: 0 }
}

const TeaserImageComponent = styled.div`
    position: relative;
    width: ${props => (props.width ? props.width : '64.29vw')};
    ${props => alignment(props.align)};
    min-width: ${props => props.minWidth}px;

    @media (max-width: ${props => props.minWidth + 20}px){
        min-width: 100%;
    }

    &::before {
        content: '';
        width: 1px;
        margin-left: -1px;
        float: left;
        height: 0;
        padding-top: ${props =>
        props.maxWidth && props.maxHeight
            ? props.maxHeight / props.maxWidth * 100
            : '66.6786666666'}%;
    }
    &::after {
        content: '';
        display: table;
        clear: both;
    }
    img {
        transition: opacity 0.5s, all 2s !important;
        will-change: transform;
    }
    &:hover,
    &.hover {
        img {
            transform: scale(1.05);
        }
    }
    a{
      display: block;
    }

    .media-video{
      @media (min-width: ${containers.ipad + 1}px) {
        position: absolute;
        position: relative;
        width: 100%;
        overflow: hidden;
        video{
          position: relative;
          height: 100%;
          width: auto;
          max-width: initial;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
    .gatsby-image-outer-wrapper {
        height: 100%;
        transform: translateY(60px);
        opacity: 0.01;
        .visible & {
            transform: translateY(0);
            transition: all 0.8s;
            opacity: 1;
        }
    }
    .gatsby-image-wrapper {
        height: 100%;
    }
`;

export default TeaserImageComponent;
